// english

export default {
  role_list_title: 'Role List',
  role_btn_add: 'Add New Role',
  role_btn_auth_menu: 'Menu Authorization',
  role_btn_auth_data: 'Data Authorization',

  // form
  role_form_name: 'Role Name',
  role_form_name_placeholder: 'Please input role name',
  role_form_access_customer: 'Customer access authorization',
  role_form_access_site: 'Site access authorization',
  role_form_email: 'Receive alarms by email',
  role_form_webui_ssh: 'WEB/SSH access',
  role_form_webui_ssh_tip1: 'Below',
  role_form_webui_ssh_tip2:
    ' 0: the highest level, 1-5: the larger the number, the smaller the permission',
  role_form_access_user: 'User access',
  role_form_access_device: 'Device configuration access',
  role_form_read: 'Read',
  role_form_write: 'Write',
  role_form_download: 'Download',
  role_form_access_params: 'Device parameter access',
  role_form_access_wiki: 'Document access',
  role_form_access_attach: 'Attachment access',

  // 权限枚举值
  role_auth: {
    customer: [
      {
        name: 'All Customers',
        value: 0,
      },
      {
        name: 'Own Customers Only',
        value: 1,
      },
      {
        name: 'Assign Customers Only',
        value: 2,
      },
    ],
    site: [
      {
        name: 'All Sites',
        value: 0,
      },
      {
        name: 'Assign Sites Only',
        value: 1,
      },
    ],
    webAccess: [
      {
        name: 'Disable WEB/SSH Root',
        value: 0,
      },
      {
        name: 'Only WEB/SSH Root',
        value: 1,
      },
      {
        name: 'Only Web Admin',
        value: 2,
      },
      {
        name: 'Only web Engineer',
        value: 3,
      },
    ],
    // 0-最高级别控制，1~5，5个不同级别控制，数字越大权限越
    levelNumber: [0, 1, 2, 3, 4, 5],
  },

  // conifrm
  role_confirm_delete_title: 'Do you confirm to delete this role?',
  role_confirm_delete_content: 'Role Name: {name}',
};
